import User from "../../../client/models/user"

export default class Vote {
  readonly id: number
  readonly value: number
  readonly user: User
  readonly createdAt: String
  readonly updatedAt: String

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.value = data.value
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt

    if (data.user) {
      this.user = new User(data.user)
    }
  }
}
